import React from "react";
import variables from "../../themes/base/styles/variables";
import { TwoRow } from "../../core/layouts";
import useResponsive from "../../core/hooks/useResponsive";

const MyNotificationsLayoutStyle = {
  style: {
    backgroundColor: variables.grey5,
    display: variables.dFlex,
    justifyContent: variables.justifyCenter,
  },
  topSectionStyle: {
    paddingTop: variables.paddingMediumLarge,
    paddingLeft: variables.paddingMedium,
    paddingBottom: variables.paddingMedium2,
  },
  linkStyle: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
  },
  backArrow: {
    width: variables.iconWidthLarge,
    height: variables.iconHeightLarge,
    marginRight: variables.marginMediumSmall,
  },
  bottomSectionStyle: {
    display: variables.dFlex,
    justifyContent: variables.justifyCenter,
    height: `calc(100vh - 11.5rem)`,
    padding: variables.paddingMedium,
    overflow: variables.overflowAuto,
  },
  bottomWrapperStyle: {
    width: variables.notificationsDetailPageWidth,
  },
};

export default function MyNotificationsLayout({ topSection, bottomSection }) {
  const responsive = useResponsive();

  return (
    <TwoRow
      style={MyNotificationsLayoutStyle.style}
      topSectionStyle={MyNotificationsLayoutStyle.topSectionStyle}
      topSection={topSection}
      bottomSectionStyle={{
        ...MyNotificationsLayoutStyle.bottomSectionStyle,
        ...(!responsive.isMd && {
          width: variables.fullWidth,
        }),
      }}
      bottomSection={
        <div style={MyNotificationsLayoutStyle.bottomWrapperStyle}>
          {bottomSection}
        </div>
      }
    />
  );
}
